export default __webpack_public_path__ + "static/media/img49.101dcb8b.png";